import clsx from "clsx";
import { runtimeConfig } from "../../lib/config";
import styles from "./InstanceTag.module.css";

/**
 * Which build you are looking at, in the topbar. A dev build says so in amber:
 * this app issues real invoices, and "am I on production?" should not need a
 * glance at the URL bar.
 */
export function InstanceTag() {
  const isDev = runtimeConfig.version === "dev" || runtimeConfig.version.includes("dirty");

  return (
    <span className={clsx(styles.tag, isDev && styles.dev)} title={`Verze ${runtimeConfig.version}`}>
      {runtimeConfig.version}
    </span>
  );
}
